import React, { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../../services/firebase';
import LoginForm from './LoginForm';
import './AuthGuard.css';

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        // User is signed in
        setIsAuthenticated(true);
        
        // Store the token for API calls
        const token = await firebaseUser.getIdToken();
        localStorage.setItem('authToken', token);
      } else {
        // User is signed out
        setIsAuthenticated(false);
        localStorage.removeItem('authToken');
      }
    });

    // Cleanup subscription
    return () => unsubscribe();
  }, []);

  const handleLoginSuccess = () => {
    // The onAuthStateChanged listener will handle the state update
    // This is just to trigger any immediate UI updates if needed
  };

  // Loading state
  if (isAuthenticated === null) {
    return (
      <div className="auth-loading">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  // Not authenticated - show login form
  if (!isAuthenticated) {
    return <LoginForm onLoginSuccess={handleLoginSuccess} />;
  }

  // Authenticated - render children
  return <>{children}</>;
};

export default AuthGuard;